import { Component, OnInit } from '@angular/core';
import { LstStorePeriodResponse } from 'src/app/shared/models/lstStorePeriodResponse';
import { StorePeriod } from 'src/app/shared/models/StorePeriod';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Store } from 'src/app/shared/models/Store';
@Component({
  selector: 'app-stored-period-dtl',
  templateUrl: './stored-period-dtl.component.html',
  styleUrls: ['./stored-period-dtl.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class StoredPeriodDtlComponent implements OnInit {

  storePeriodResponse : LstStorePeriodResponse;
  lstStorePeriod: StorePeriod[];
  selectedPeriod: StorePeriod;
  currentPeriod : string;
  storeParent: Store;

  lstPeriodStore : any[];
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router) { 
      const navigation = this.router.getCurrentNavigation();
      const storeParent = navigation.extras.state as Store;
      if(storeParent){
        this.storeParent = storeParent;
        this.executeOperation("R");
      }else{
        this.redirectParent();
      }
    }

  ngOnInit(): void {
    this.getPeriodToday();
  }

  getPeriodToday(){
    let currentYear = new Date().getFullYear(); 
    let currentMonth = new Date().getMonth() +1;
    let period = currentMonth < 7 ? 1 : 2;
    this.currentPeriod = currentYear + " - " + period;
  }

  createPeriod():void{
    this.confirmationService.confirm({
      message: '¿ Está seguro de crear un nuevo periodo ?',
      header: 'Crear Periodo',
      icon: 'pi pi-save',
      acceptButtonStyleClass: "p-button-info",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
          this.executeOperation("C");
          
      }
    });
  }

  redirectParent(){
    let navigationExtras: NavigationExtras = {
      state : this.storeParent != null ?  JSON.parse(JSON.stringify(this.storeParent)) : null
    }

    this.router.navigate(['catalog/periodStore'],navigationExtras);
  }

  executeOperation(operation:string){
    this.apiService.operetaionPeriodStore(this.storeParent.supStoreId,this.storeParent.storeId,operation).then(
      storePeriod => {
        this.storePeriodResponse = storePeriod;

        const listFilterStore = this.storePeriodResponse.lstStorePeriod.filter( (store) => store.status != "C");
        this.lstStorePeriod = listFilterStore;

        if(operation === "C"){
          this.messageService.add({severity:'success', summary: 'Crear Periodo', detail: 'Se creó periodo correctamente', life: 3000});
        }else if(operation == "D"){
          this.messageService.add({severity:'warn', summary: 'Eliminar Periodo', detail: 'Se elimino periodo correctamente', life: 3000});
        }

    });
  }

  deletePeriod(){
    this.confirmationService.confirm({
      message: '¿Está seguro de Eliminar periodo?',
      header: 'Eliminar Periodo',
      icon: 'pi pi-trash',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.executeOperation("D");
      }
    });
  }

}
